import { Col, Image, Row } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AssetPath from "../../AssetPath/AssetPath";
import ButtonBox from "../../Components/ButtonBox/ButtonBox";
import ModalBox from "../../Components/ModalBox/ModalBox";
import PageTitle from "../../Components/PageTitle/PageTitle";
import InnovatePharmaEventDetails from "../Agenda/InnovatePharmaEventDetails";
import OldAgendaList from "../Agenda/OldAgendaList";
import Speakers from "../Agenda/Speakers";
import GalleryData from "../Gallery/GalleryData";
import SubmitAbstractForm from "../LandingPage/SubmitAbstractForm";

export default function InnovatePharma2024() {
  const [open, setOpen] = useState();
  const history = useNavigate();

  return (
    <>
      <PageTitle
        mainTitle="Innovate pharma 2024"
        breadcrumbItems={[
          {
            name: "Innovate pharma 2024",
            path: "/innovate-pharma-2024-bridging-continents-for-a-healthier-tomorrow",
          },
        ]}
        image={AssetPath.breadcrumb.innovatePhrama2024}
        strokeType="green"
      />
      
      <OldAgendaList title="Innovate Pharma 2024" />

      <section
        className="presentations our-team spacing position-relative bg-light-green"
        data-aos="fade-up"
      >
        <div className="container">
          <h3 className="text-primary text-center mb-3 fw-bold">
            Innovate Pharma 2024 Presentation
          </h3>
          <ul className="list-unstyled">
            {InnovatePharmaEventDetails.map((data, i) => (
              <li>
                <a
                  href={data.path}
                  target="_blank"
                  rel="noreferrer"
                  className="d-flex align-items-center   border rounded mb-2 text-primary"
                >
                  <div className="count d-flex align-items-center justify-content-center font-4 me-3 bg-primary text-white">
                    {i + 1}
                  </div>
                  <div className="text-left">
                    <h5 className="d-block w-100 mb-0 h6">{data.title}</h5>
                    <div className="d-block">
                      <p className="mb-0  font-4">
                        <strong>{data.speaker}</strong>• <em>{data.role}</em>{" "}
                        {data.company ? " •" : ""}{" "}
                        <strong>{data.company} </strong>
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <Speakers />
      <section className="spacing bg-light-green">
        <div className="container">
          <div className="text-center mb-2">
            <h4 className="title mb-3 text-primary fw-bold text-center">
              Gallery
            </h4>
          </div>
          {GalleryData[0]?.innovatePharma && (
            <Row gutter={[16, 24]}>
              {GalleryData[0].innovatePharma.images
                .slice(0, 12)
                .map((image, i) => (
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                    key={i}
                  >
                    <div className="gallery-details card border p-2">
                      <Image
                        src={image}
                        alt={`Innovate Pharma 2024`}
                        className="w-100 mb-2"
                        loading="lazy"
                      />
                    </div>
                  </Col>
                ))}
            </Row>
          )}

          <div className="text-center mt-3">
            <ButtonBox
              variant="primary"
              label="Load More Images"
              onClick={() =>
                history(
                  "/innovate-pharma-2024-bridging-continents-for-a-healthier-tomorrow-gallery"
                )
              }
              rightArrowIcon
            />
          </div>
        </div>
      </section>

      <ModalBox
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
      >
        <SubmitAbstractForm />
      </ModalBox>
    </>
  );
}
